var $ = global.jQuery = global.$;
var widgets = require('../lib/widgets');
var _Base = require('./_Base');
var Loading = require('./Loading');
var _find = require('lodash/collection/find');
var _findIndex = require('lodash/array/findIndex');
var _isEqual = require('lodash/lang/isEqual');
var displayTmpl = require('../templates/addressDisplay.dot');
/**
 * Address selection form
 * @class
 * @extends _Base
 */
var BookingAddress = _Base.extend(
  /** @lends BookingAddress.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;
    this.customerAddressUrl = this.$el.data('customerAddresses');

    this.loadingWidget = new Loading(this.$el);
  },
  onWidgetsReady: function() {
    var self = this;
    this.$formSubmitBtn = this.$el.find('[data-form-submit]');
    this.$addAddressBtn = this.$el.find('[data-address-add]');
    this.$cancelAddressBtn = this.$el.find('[data-address-cancel]');
    this.$displayAddress = this.$el.find('[data-address-display]');
    this.AddressForm = widgets.getById('AddressForm');
    this.AddressSelection = widgets.getById('AddressSelection');
    this.AddressSelect = widgets.getById('AddressSelect');

    this.$formSubmitBtn.on('click', function(event) {
      event.preventDefault();
      self.AddressSelection.$el.submit();
    });

    this.$addAddressBtn.on('click', function(event) {
      event.preventDefault();
      self.showAddressForm(true);
    });

    this.$cancelAddressBtn.on('click', function(event) {
      event.preventDefault();
      self.hideAddressForm();
    });

    this.$displayAddress.on('click', '[data-address-edit]' , function(event) {
      event.preventDefault();
      self.showAddressForm();
    });

    this.AddressForm.$el.on('Field:Updated', function() {
      var current = self.currentAddress;
      if (!_isEqual(current, self.AddressForm.getFieldValues()) && self.AddressForm.$el.is(':visible')) {
        self.AddressForm.$submitButton.removeAttr('disabled');
      } else {
        self.AddressForm.$submitButton.attr('disabled','disabled');
      }
    });

    this.AddressSelect.$el.on('Field:Updated', function(event, name, value){
      value = Number(value);
      self.currentIndex = _findIndex(self.currentAddresses, {'Id':value});
      self.hideAddressForm();
    });

    this.$el.on('Address:Saved', function(event, addressResponse) {
      var index = _findIndex(addressResponse.Items, {'Id':addressResponse.SelectedId});
      this.$el.trigger('Loading:Success');
      setTimeout(function(){
        this.updateAddressOptions(addressResponse.Items, index);
      }.bind(this), 300);
    }.bind(this));

    this.getCustomerAddresses()
      .done(function(response) {
        if (response.Value) {
          var index = response.Value.SelectedId ? _findIndex(response.Value.Items, {'Id':response.Value.SelectedId}) : _findIndex(response.Value.Items, 'IsPrimary');
          self.$el.trigger('Loading:Success');
          self.updateAddressOptions(response.Value.Items, index);
        } else if (response.Error && response.Error !== '') {
          self.$el.trigger('Loading:Failed', [response.Error]);
        }
      })
      .fail(function() {
        self.$el.trigger('Loading:Failed');
      });
  },
  hideAddressForm: function() {
    this.$displayAddress.show();
    this.currentAddress = this.currentAddresses[this.currentIndex];
    this.$displayAddress.show().html(displayTmpl(this.currentAddress));
    this.AddressForm.setAddress(this.currentAddress);
    this.AddressForm.$el.hide();
  },
  showAddressForm: function(reset) {
    this.$displayAddress.hide();
    if (reset) {
      this.AddressForm.reset();
      this.currentAddress = this.AddressForm.getFieldValues();
    } else {
      this.currentAddress = this.currentAddresses[this.currentIndex];
    }
    this.AddressForm.setAddress(this.currentAddress);
    this.AddressForm.$el.show();
  },
  updateAddressOptions: function(addresses, index) {
    this.currentAddresses = addresses;
    this.AddressSelect.updateSelectOptions(this.createSelectOptions(addresses));
    this.selectAddress(index);
  },
  selectAddress: function(index) {
    this.AddressSelect.setSelectIndex(index);
    this.AddressForm.$submitButton.attr('disabled','disabled');
  },
  createSelectOptions: function(addresses) {
    var selectOptions = [];
    $.each(addresses, function() {
      var address = {
        Text:  this.PostCode + ', ' + this.Address1 + (this.Address2 ? ', ' + this.Address2 : ''),
        Value: this.Id
      };
      selectOptions.push(address);
    });
    return selectOptions;
  },
  getCustomerAddresses: function() {
    return $.ajax({
      type: 'GET',
      url: this.customerAddressUrl
    });
  }
});

module.exports = BookingAddress;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/BookingAddress.js
// module id = 67
// module chunks = 0